import { useState } from "react";

export const useHotelRulesModal = () => {
  const [isRulesModalVisible, setIsRulesModalVisible] = useState(false);

  const showHotelRulesModal = () => {
    setIsRulesModalVisible(true);
  };

  const hideHotelRulesModal = () => {
    setIsRulesModalVisible(false);
  };

  return {
    isRulesModalVisible,
    showHotelRulesModal,
    hideHotelRulesModal,
  };
};
